import React, { Component } from 'react'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { getUserFullNameFromState, constants, mixpanel } from 'common/helpers'
import ValueLink from 'sb-valuelink'
import cx from 'classnames'
import { connect } from 'redaction'
import { FormattedMessage } from 'sb-react-intl'

import { Button, buttonMessages } from 'components/_new/controls'
import ModalFooter from 'components/modal/ModalFooter/ModalFooter'
import Modal from 'components/modal/Modal/Modal'

import messages from './messages'
import s from './SubscriptionWasCancelledModal.scss'


class SubscriptionWasCancelledModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    userFullName: PropTypes.string,
  }

  static defaultProps = {
    name: constants.modals.cancelSubscription.SubscriptionWasCancelled,
  }

  constructor() {
    super()

    this.state = {
      activeRateNum: 0,
    }
  }

  resubscribe = () => {
    actions.models.subscription.resubscribe({
      resubscribeCode: constants.resubscribeTypes.resubnew,
      popup: constants.analyticsEvents.resubscribePopup.postCancel,
    })
      .then(this.close)
  }

  finish = () => {
    const { activeRateNum } = this.state

    mixpanel.track(constants.analyticsEvents.cancelFlow.resubscribeNps, {
      type: activeRateNum,
    })

    if (activeRateNum) {
      actions.models.subscription.rateResubscribe(activeRateNum)
    }

    this.close()
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, userFullName } = this.props
    const activeRateNumLink = ValueLink.state(this, 'activeRateNum')

    return (
      <Modal
        name={name}
        title={messages.title}
      >
        <FormattedMessage className={s.text} tag="div" {...messages.text} values={{ userName: userFullName }} />
        <Button
          className={s.button}
          title={messages.resubscribeButton}
          size="md"
          color="brand"
          dataTestId="resubscribeButton"
          onClick={this.resubscribe}
        />
        <FormattedMessage className={s.resubscribeQuestionTitle} tag="div" {...messages.resubscribeQuestion} />
        <div className={s.rate}>
          {
            [ ...Array(10).keys() ]
              .map((num) => {
                const rateNumContainerClassName = cx(s.rateNum, {
                  [s.active]: activeRateNumLink.value === num,
                })

                return (
                  <div
                    key={num}
                    className={rateNumContainerClassName}
                    onClick={() => activeRateNumLink.set(num)}
                  >
                    <div className={s.rateNumTitle}>{num}</div>
                  </div>
                )
              })
          }
        </div>
        <ModalFooter>
          <Button
            title={buttonMessages.finish}
            size="md"
            color="brand"
            dataTestId="finishButton"
            onClick={this.finish}
          />
        </ModalFooter>
      </Modal>
    )
  }
}


export default connect({
  userFullName: (state) => getUserFullNameFromState(state),
})(SubscriptionWasCancelledModal)
